import React from 'react';
import { useKeyboardShortcuts } from '../../keyboard/hooks/useKeyboardShortcuts';
import KeyboardShortcutsHelp from './KeyboardShortcutsHelp';
import NavigationSearch from './NavigationSearch';

/**
 * Provider component that sets up keyboard shortcuts
 * This component doesn't render anything, it just initializes the keyboard shortcuts
 */
const KeyboardShortcutsProvider = ({ children }) => {
  // Initialize keyboard shortcuts
  const { 
    showHelp, 
    setShowHelp, 
    showNavigationSearch, 
    setShowNavigationSearch
  } = useKeyboardShortcuts();
  
  return (
    <>
      {children}
      <KeyboardShortcutsHelp 
        visible={showHelp} 
        onClose={() => setShowHelp(false)} 
      />
      <NavigationSearch
        visible={showNavigationSearch}
        onClose={() => setShowNavigationSearch(false)}
      />
    </>
  );
};

export default KeyboardShortcutsProvider; 